import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-copyright',
  templateUrl: './section-copyright.component.html',
  styleUrls: ['./section-copyright.component.scss']
})
export class SectionCopyrightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
